import React from "react";

export const UiOptionBox = ({ label, value, selected, onClick, className = "" }) => {
  return (
    <div
      className={`df-option-box ${selected ? "df-option-box--selected" : ""} ${className}`}
      onClick={() => onClick && onClick(value)}
    >
      <span className="df-option-box__label">{label}</span>
    </div>
  );
};


